import * as actions from 'actions';

const INITIAL_STATE = {
  isFetching: false,
  isAvailable: false,
  services: [],
  languages: [],
  locations: [],
  schools: []
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.F2F_STATUS_FETCH: {
      return {
        ...state,
        isFetching: true
      };
    }

    case actions.F2F_STATUS_FETCH_SUCCESS: {
      return {
        ...state,
        isAvailable: action.result.available,
        isFetching: false,
        services: action.result.services
      };
    }

    case actions.F2F_STATUS_FETCH_ERROR: {
      return {
        ...state,
        isFetching: false
      };
    }

    case actions.F2F_LANGUAGES_FETCH_SUCCESS: {
      return {
        ...state,
        languages: action.result
      };
    }

    case actions.F2F_LOCATIONS_FETCH_SUCCESS: {
      return {
        ...state,
        locations: action.result
      };
    }

    case actions.F2F_SCHOOLS_FETCH_SUCCESS: {
      return {
        ...state,
        schools: action.result
      };
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/f2f/reducer.js
 **/